import React from 'react';

import {FmlxModal} from 'fmlx-common-ui';
import {useSelector} from 'react-redux';

import {ModalType} from '@/constants/modalEnum';
import {getModal} from '@/selectors/modalSelector';

import ModalGeneric from './ModalGeneric';
import ModalGenericError from './ModalGenericError';

function Modal() {
  const {show, type, size, inlineMessage, hideCloseButton, disableBlur} = useSelector(getModal);
  const featureList = {
    [ModalType.GENERIC]: ModalGeneric,
    [ModalType.GENERIC_ERROR]: ModalGenericError,
  };
  const Feature = featureList[type];

  if (!show || !Feature) return null;

  return (
    <FmlxModal
      id="root-modal"
      open={show}
      size={size}
      inlineMessage={inlineMessage}
      hideCloseButton={hideCloseButton}
      disableBlur={disableBlur}
      customHeader={<Feature.Header />}
      customFooter={<Feature.Footer />}
    >
      {Feature.Content ? <Feature.Content /> : null}
    </FmlxModal>
  );
}

export default Modal;
